import React, { useEffect, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Header from './components/Header/Header';
import BemvindoSection from './components/BemvindoSection/BemvindoSection';
import ImagemQuintaSection from './components/ImagemQuintaSection/ImagemQuintaSection';
import DiferenciacaoSection from './components/DiferenciacaoSection/DiferenciacaoSection';
import Casas from './components/Casas/Casas';
import ProvaSocialSection from './components/ProvaSocialSection/ProvaSocialSection';
import RegionSection from './components/RegionSection/RegionSection';
import ContactMapSection from './components/ContactMapSection/ContactMapSection';
import PequenaDescricaoSection from "./components/PequenaDescricaoSection/PequenaDescricaoSection";
import HomeHeroSection from "./components/HomeHeroSection/HomeHeroSection";
import SiteStructuredData from "./components/StructuredData/SiteStructuredData";
import SiteOpenGraph from "./components/OpenGraph/SiteOpenGraph";
import RoutePreloader from "./components/RoutePreloader/RoutePreloader";
import {
  VillaDetail,
  ReservationRequests,
  RegionDetail,
} from "./utils/routePreload";



function App() {
  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };

  const MainContent = () => {
    const location = useLocation();

    useEffect(() => {
      const hash = location.hash || window.location.hash;
      if (hash) {
        const id = hash.replace('#', '');
        // small timeout to allow layout to settle
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    }, [location]);

    return (
      <>
        <div className="main-content">
          <HomeHeroSection />
        </div>

        <div id="tapada-sao-domingos">
          <BemvindoSection />
        </div>
        <div id="a-regiao">
          <ImagemQuintaSection />
        </div>
        <div id="diferenciacao">
          <DiferenciacaoSection />
        </div>
        <div id="villas">
          <Casas />
        </div>
        <div id="gardens-heritage">
          <PequenaDescricaoSection />
        </div>
        <div id="prova-social">
          <ProvaSocialSection />
        </div>
        <div id="a-regiao-section">
          <RegionSection />
        </div>
        <div id="contactos">
          <ContactMapSection />
        </div>
      </>
    );

  };

  return (
    <LanguageProvider>
      <BrowserRouter>
        <RoutePreloader />
        <SiteStructuredData />
        <SiteOpenGraph />
        <ScrollToTop />
        <Header />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<MainContent />} />
            <Route path="/villa/:slug" element={<VillaDetail />} />
            <Route path="/reservations" element={<ReservationRequests />} />
            <Route path="/region" element={<RegionDetail />} />
            <Route path="/regiao" element={<RegionDetail />} />
          </Routes>
        </Suspense>
        <Analytics />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
